import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';


const AdminPage = () => {

    let navigate = useNavigate();
    const location = useLocation();
    const [authenticated, setAuthenticated] = useState(false);
    const [csvDownloaded, setCsvDownloaded] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [apiKey, setApiKey] = useState('');
    const backendURL = process.env.REACT_APP_BACKEND_URL;

    useEffect(() => {
        if (!location.state) {
            navigate('/');
        }
    }, []);

    const goToOCR = () => {
        navigate('/ocr', { state: "endUser" });
    }

    const handleAuth = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('username', username);
            formData.append('password', password);

            const response = await fetch(`${backendURL}auth`, {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                const data = await response.json();

                if (data.key) {
                    setAuthenticated(true);
                    setApiKey(data.key);
                    toast.success('Login successful!');
                } else {
                    toast.error('Authentication failed!');
                }

            } else {
                toast.error('Login failed');
            }
        } catch (error) {
            console.error('Login error:', error);
            toast.error('An error occurred during login');
        }
    };

    const escapeCSVValue = (value) => {
        if (Array.isArray(value)) {
            value = value.join(' | ');
        }
        if (value === null || value === undefined) {
            return '';
        }

        value = String(value);

        // Escape value if it contains commas, quotes, or newlines
        if (/[",\n]/.test(value)) {
            value = `"${value.replace(/"/g, '""')}"`;
        }
        return value;
    };

    const convertJSONToCSV = (data) => {
        if (!Array.isArray(data) || data.length === 0) return '';

        // Step 1: Collect all unique keys from all objects
        const allKeys = new Set();
        data.forEach(obj => {
            Object.keys(obj).forEach(key => allKeys.add(key));
        });
        allKeys.delete("audioBase64");
        const headers = Array.from(allKeys);

        // Step 2: Convert each object to a CSV row
        const rows = data.map(obj => {
            return headers.map(header => escapeCSVValue(obj[header])).join(',');
        });

        // Step 3: Combine header and rows into final CSV
        const csv = [headers.join(','), ...rows].join('\n');
        return csv;
    };

    const downloadDetails = async () => {
        const dateInput = document.querySelector('input[type="date"]');
        if (!dateInput || !dateInput.value) {
            toast.warn("Please select a date first.");
            return;
        }

        const selectedDateStr = dateInput.value;
        const selectedDate = new Date(selectedDateStr + 'T00:00:00');

        const today = new Date();
        const currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

        if (selectedDate > currentDate) {
            toast.error("Please select a date that is today or earlier.");
            return;
        }

        try {
            const fecthUrl = new URL(`${backendURL}db/`);
            fecthUrl.searchParams.append('date', selectedDateStr);
            const response = await fetch(fecthUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey
                }
            });
            if (!response.ok) {
                toast.error("An error occured while trying to fetch records");
            }

            const data = await response.json();

            if (!data || data.length === 0) {
                toast.info("No data to download");
                return;
            }

            // Final CSV content
            const csvContent = convertJSONToCSV(data);

            // Trigger download
            const blob = new Blob([csvContent], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'All_Data.csv';
            a.click();
            URL.revokeObjectURL(url);
            setCsvDownloaded(true);
        } catch (error) {
            console.error('Error during download:', error);
            toast.error("Failed to fetch or download data.");
        }
    };

    return (
        <div className="bg-white min-h-screen flex items-center justify-center px-4">
            <form className="bg-custom-bg bg-cover shadow-md rounded-xl p-8 w-full max-w-sm" onSubmit={handleAuth}>
                <h2 className="playwrite text-xl font-bold text-center text-green-800 mb-6">Login</h2>

                <div className="mb-4">
                    <label className="block text-gray-700 font-semibold mb-1">Username</label>
                    <input
                        type="text"
                        className="w-full border border-gray-300 rounded px-3 py-2"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>

                <div className="mb-4">
                    <label className="block text-gray-700 font-semibold mb-1">Password</label>
                    <input
                        type="password"
                        className="w-full border border-gray-300 rounded px-3 py-2"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>

                {/* Date field - visible only after auth */}
                {authenticated && (
                    <div className="mb-4">
                        <label className="block text-gray-700 font-semibold mb-1">Date</label>
                        <input
                            type="date"
                            className="w-full border border-gray-300 rounded px-3 py-2"
                        />
                    </div>
                )}

                {/* Show "Continue" if not authenticated */}
                {!authenticated && (
                    <button
                        type="submit"
                        className="button-style w-full px-4"
                    >
                        Continue
                    </button>
                )}

                {/* Show "Download" if authenticated */}
                {authenticated && (
                    <>
                        <button
                            type="button"
                            className="w-full bg-green-600 active:bg-green-700 text-white font-bold py-2 px-4 rounded transition"
                            onClick={downloadDetails}
                        >
                            Download CSV
                        </button>
                    </>
                )}
                <br/><br/>
                {csvDownloaded && (
                    <>
                        <button
                            type="button"
                            className="w-full bg-blue-600 active:bg-blue-700 text-white font-bold py-2 px-4 rounded transition"
                            onClick={goToOCR}
                        >
                            Scan A Card
                        </button>
                    </>
                )}
            </form>
        </div>
    );
};

export default AdminPage;